import React from 'react'
import {
  HeaderRightArea,
  ToggleButton,
  getAreaLineStyles
} from './CollapsibleCard.styles'
import { HeightClass } from '~/utils/enum/classes'
import useIsOpen from '~/hooks/useIsOpen'
import Icon from '~/components/Icon'
import { AreaLineProps } from '~/components/AreaLine/type'
import CardWithAreaLine from '../CardWithAreaLine'
import { CardWithAreaLineProps } from '../CardWithAreaLine/CardWithAreaLine'

type CollapsibleCardProps = CardWithAreaLineProps & {
  defaultOpenState?: boolean
  disabled?: boolean
}

export const iconSize: Record<HeightClass, HeightClass> = {
  extraSmall: 'regular',
  small: 'regular',
  semiSmall: 'large',
  regular: 'large',
  semiLarge: 'large',
  large: 'large',
  extraLarge: 'extraLarge',
  semiGiant: 'semiGiant'
}

const CollapsibleCard = ({
  rightHeaderElement,
  areaLineProps,
  defaultOpenState = false,
  disabled = false,
  children,
  ...cardWithAreaLineProps
}: CollapsibleCardProps & React.HTMLAttributes<HTMLDivElement>) => {
  const { isOpen, open, close } = useIsOpen(defaultOpenState)

  const { heightClass } = cardWithAreaLineProps
  const arrowIconSize: HeightClass = iconSize[heightClass] || 'regular'

  const toggleButton = (
    <HeaderRightArea>
      {rightHeaderElement}
      <ToggleButton
        disabled={disabled}
        arrowIconSize={arrowIconSize}
        onClick={isOpen ? close : open}
      >
        <Icon
          iconName={
            isOpen && !disabled ? 'DropdownArrowUp' : 'DropdownArrowLow'
          }
          icSize={arrowIconSize}
        />
      </ToggleButton>
    </HeaderRightArea>
  )

  const forwardAreaLineProps: AreaLineProps = {
    ...areaLineProps,
    style: { ...areaLineProps?.style, ...getAreaLineStyles(isOpen) },
    rightAreaElement: toggleButton
  }

  return (
    <CardWithAreaLine
      areaLineProps={forwardAreaLineProps}
      {...cardWithAreaLineProps}
    >
      {isOpen && !disabled ? children : null}
    </CardWithAreaLine>
  )
}

export default CollapsibleCard
